.section {
  margin: 24px 0;
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

.heading {
  font-size: 1rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: var(--color-text-secondary);
  margin: 0;
}

.navButtons {
  display: flex;
  gap: 4px;
}

.navBtn {
  background: none;
  border: 1px solid var(--color-border);
  border-radius: 4px;
  width: 28px;
  height: 28px;
  cursor: pointer;
  color: var(--color-text-secondary);
  font-size: 0.875rem;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: border-color 0.15s, color 0.15s;
}

.navBtn:hover {
  border-color: var(--color-accent);
  color: var(--color-accent);
}

.track {
  display: flex;
  gap: 16px;
  overflow-x: auto;
  scroll-snap-type: x mandatory;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  padding-bottom: 4px;
}

.track::-webkit-scrollbar {
  display: none;
}

.card {
  flex: 0 0 260px;
  scroll-snap-align: start;
  background-color: var(--color-bg-card);
  border: 1px solid var(--color-border);
  border-radius: 8px;
  padding: 0;
  cursor: pointer;
  transition: box-shadow 0.2s;
  overflow: hidden;
}

.card:hover {
  box-shadow: 0 4px 16px var(--color-shadow);
}

.cardImage {
  width: 100%;
  height: 120px;
  object-fit: cover;
  display: block;
}

.cardCategory {
  font-size: 0.68rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--color-accent);
  margin-bottom: 6px;
  padding: 14px 14px 0;
}

.cardTitle {
  font-size: 0.9rem;
  line-height: 1.35;
  color: var(--color-text-primary);
  margin: 0;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  padding: 0 14px 14px;
}

.skeletonCard {
  flex: 0 0 260px;
  height: 120px;
  border-radius: 8px;
  background-color: var(--color-skeleton);
  animation: pulse 1.5s ease-in-out infinite;
}

@keyframes pulse {
  0%, 100% { opacity: 1; }
  50%       { opacity: 0.5; }
}
